import { Carousel } from 'antd';
import styled from "styled-components"
const SliderContainer = styled.div`
    width:58vw;
    height:30vh;
    margin-top:15vh;
    margin-left:24vw;
    @media (max-width:767px){
        margin-left:10vw; 
    }
    .slider-field{
        width:58vw;
        height:40vh;
        border-radius:25px;
        overflow:hidden;
        @media (max-width:1023px) and (min-width:768px){
            width:68vw;
        }
        @media (max-width:767px){
            width:80vw;
        }
        .slider-imgfield{
            width:100%;
            height:40vh;
            .slider-content{
                height:100%;
                width:100%;
                object-position:bottom;
                object-fit:cover;
            }
        }
        
    }
`
export default function Slider(){
    const contentStyle = {
        height: 'vh',
        color: '#fff',
        lineHeight: '160px',
        textAlign: 'center',
        background: '#364d79',
    };
    return(
        <SliderContainer>
            <Carousel autoplay className='slider-field'>
                <div className='slider-imgfield'>
                    <img src='/Slider/banner1.jpg' className='slider-content'></img>
                </div>
                <div className='slider-imgfield'>
                    <img src='/Slider/banner2.jpg' className='slider-content'></img>
                </div>
                <div className='slider-imgfield'>
                    <img src='/Slider/banner3.jpg' className='slider-content'></img>
                </div>
            </Carousel>
        </SliderContainer>
    )
}